import React from 'react';
import * as ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { httpClient } from '../../lib/utils';
import { LOGIN_SET_THEME } from '../constants/ActionTypes';

const saveStateDefaults = {
    saving: false,
    saveResult: { type: 'NA' },
    storeIsChanged: false,
    changed: false,
    configChange: false,
    themeChange: false,
    themeChangeCategory: 'SBE',  // Default theme change category
    thirdpartyChange: false
};

const saveReducer = handleActions(
    {
        [ActionTypes.CHANGE_FIELDS]: state => {
            return {
                ...state,
                changed: true,
                configChange: true
            };
        },
        [ActionTypes.SAVE_SAVING]: (state, _) => {
            return { ...state, app: { ...state.app, saving: true } };
        },
        [ActionTypes.SAVE_SUCCESSFUL]: (state, action) => {
            return { ...state, saving: false, saveResult: { value: action.success }, type: 'success' };
        },
        [ActionTypes.SAVE_FAILED]: (state, action) => {
            return { ...state, saving: false, saveResult: { value: action.error }, type: 'error' };
        },
        // eslint-disable-next-line import/namespace
        [ActionTypes.SOME_ACTION]: (state, action) => {
            return { ...state, something };
        },
        [ActionTypes.SAVE_STORE_CHANGED]: (state, action) => {
            return {
                ...state,
                storeIsChanged: true
            };
        },
        [ActionTypes.EDIT_STORE_CHANGED]: (state, action) => {
            return {
                ...state,
                changed: true,
                configChange: action.configChange,
                themeChange: action.themeChange,
                themeChangeCategory: action.themeChangeCategory || state.themeChangeCategory || 'SBE',
                thirdpartyChange: action.thirdpartyChange
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.SAVE_STORE_SAVED_ON_SERVER]: (state, action) => {
            return {
                ...state,
                changed: false,
                configChange: !action.configSaved,
                themeChange: !action.themeSaved,
                themeChangeCategory: !action.themeSaved ? state.themeChangeCategory : 'SBE',  // Reset to SBE when theme is saved
                thirdpartyChange: !action.thirdpartyChange
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_SPINNER1_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true,
                themeChange: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_SPINNER2_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true,
                themeChange: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_DISABLED_FONT_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true,
                themeChange: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_DISABLED_BACKGROUND_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true,
                themeChange: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINK_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINK_TEXT_DECORATION]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_ICON_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_TEXT_DECORATION]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_SIZE]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_TEXT_TRANSFORM]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_WEIGHT]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_STYLE]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_ICON_SIZE]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_TEXT_TRANSFORM]: (state, action) => {
            return {
                ...state,
                changed: true,
                themeChange: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_FONT]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_FONT_SIZE]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_FONT_WEIGHT]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_FONT_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_TEXT_DECORATION]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_FONT_STYLE]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_BORDER_STYLE]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_BORDER_WIDTH]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_LINE_HEIGHT]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_TEXT_ALIGN]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_PRIMARY_BACKGROUND_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_GLOBAL_SET_THEME_SECONDARY_BACKGROUND_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_COLORS_SET_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_BACKGROUND_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_BUTTON_COLOR_NORMAL]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_BUTTON_COLOR_HOVER]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_BUTTON_COLOR_DISABLED]: (state, action) => {
            return {
                ...state,
                changed: true,
                themeChange: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT_COLOR]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_TEXT_ALIGN]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT_SIZE]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT_STYLE]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT_WEIGHT]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_BUTTON_STYLE]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_BUTTONS_SET_BORDER_WIDTH]: (state, action) => {
            return {
                ...state,
                changed: true
            };
        },
        [ActionTypes.THEME_MODIFY_KEY]: (state, action) => {
            return {
                ...state,
                changed: true,
                themeChange: true,
                payload: action
            };
        },
        [ActionTypes.LOGIN_SET_THEME]: state => {
            return {
                ...state,
                themeChange: false,
                themeChangeCategory: 'SBE'  // Reset category when new theme is loaded
            };
        },
        [ActionTypes.LOGIN_SET_CONFIG]: state => {
            return {
                ...state,
                configChange: false
            };
        },
        [ActionTypes.SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG]: (state, action) => {
            return {
                ...state,
                changed: true,
                configChange: true,  // Mark as a config change instead of theme change
                themeChange: false   // Make sure it's not considered a theme change
            };
        },
    },
    saveStateDefaults
);

const actions = {
    saveTheme(data, chain, brand, hotel, contentCode, contentName) {
        return dispatch => {
            httpClient
                .post(`/ct-presentation-service/v1/presentation/transformed/theme`, data, {
                    params: {
                        hotelId: (hotel.Id && hotel.Id) || '',
                        chain: (chain.Id && chain.Id) || '',
                        brand: (brand.Id && brand.Id) || '',
                        contentName: (contentName && contentName) || ''
                    }
                })
                .then(
                    success => dispatch(actions.saveSuccessful(success)),
                    error => dispatch(actions.saveFailed(error))
                );
        };
    },
    initSave() {
        return { type: ActionTypes.SAVE_SAVING };
    },
    saveSuccessful(success) {
        return { type: ActionTypes.SAVE_SUCCESSFUL, success: success };
    },
    saveFailed(error) {
        return { type: ActionTypes.SAVE_FAILED, error: error };
    },
    storeHasChanged: () => {
        return {
            type: ActionTypes.SAVE_STORE_CHANGED
        };
    }
};

export { actions, saveReducer };



// WEBPACK FOOTER //
// ./src/store/SaveStore.js